import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label"]
  static values = { title: String, url: String }

  async share() {
    if (navigator.share) {
      await navigator.share({ title: this.titleValue, url: this.urlValue })
      return
    }

    await navigator.clipboard.writeText(this.urlValue)
    this.labelTarget.textContent = "Odkaz zkopírován"
    window.setTimeout(() => { this.labelTarget.textContent = "Sdílet inzerát" }, 1800)
  }
}
